module.exports = __webpack_public_path__ + "static/img/9_2.348081ef.jpg";